import { sepetHesaplanirMi } from './kanal';

/** Ust kartlardan secilen, Ciro trendi grafiginin cizdigi olcu (kullanici, 2026-11-01). */
export type SaOlcu = 'ciro' | 'fis' | 'sepet' | 'kar';

/** Grafik metinlerindeki ad: "Günlük fiş", "Fiş trendi", cubugun ipucu. */
export const OLCU_AD: Record<SaOlcu, string> = { ciro: 'ciro', fis: 'fiş', sepet: 'sepet ortalaması', kar: 'brüt kâr' };

export const OLCU_TREND_BASLIK: Record<SaOlcu, string> = {
  ciro: 'Ciro trendi', fis: 'Fiş trendi', sepet: 'Sepet ortalaması trendi', kar: 'Brüt kâr trendi',
};

export interface OlcuBaglami {
  tekGun: boolean;
  kanal: string | null;
  karVar: boolean;
}

/**
 * Tek gunde grafik saatliktir: saatlik veride ciro ve fis var, kar yok, sepet Magaza'ya suzulemiyor.
 * Sepet ayrica yalniz Magaza kanalinda hesaplanir (`sepetHesaplanirMi`).
 */
export function olcuSecilebilir(olcu: SaOlcu, b: OlcuBaglami): boolean {
  if (olcu === 'kar') return b.karVar && !b.tekGun;
  if (olcu === 'sepet') return !b.tekGun && sepetHesaplanirMi(b.kanal);
  return true;
}
